// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image__Hw3pnbUzlr{width:300px}`, "",{"version":3,"sources":["webpack://./src/assets/components/404/notFound.module.scss"],"names":[],"mappings":"AAAA,mBACE,WAAA","sourcesContent":[".image {\n  width: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `image__Hw3pnbUzlr`
};
export default ___CSS_LOADER_EXPORT___;
